// ActionRequiredTableHeader.tsx
import { FC } from "react";
import { ACTION_REQUIRED } from "src/constants/todos";
import { headerPorps } from "../types";

const ActionRequiredTableHeader: FC<headerPorps> = ({queryParam,changeIdOrder}) => (
  <thead className="sticky-top z-1">
   
    <tr className="text-center align-items-center">
     
       {ACTION_REQUIRED.map((tableHeader, index) => (
                 <th key={index}
                onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
              >
                <span role={tableHeader.value === '' ? "textbox" : "button"}
                  className={
                    tableHeader.value === '' ?
                      'fw-bold fs-6 lh-base' :
                      'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                  }
                >{tableHeader.label}
                  {(queryParam as any).sort_by === tableHeader.value ? (
                    <i className={`bi ${(queryParam as any).direction === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
                  ) : null}
                </span>
              </th>
              ))}
    </tr>
  </thead>
);

export default ActionRequiredTableHeader;
